export default __webpack_public_path__ + "static/media/Claude_Monet_Waterlilies_40_x_60_cm.eb2ddcff.jpg";